import { AxiosError } from 'axios'
import { createAsyncThunk, createSlice, isAnyOf } from '@reduxjs/toolkit'
import addCurrencyListApi from '../../../../middleware/api/Invoicing/Invoices/Settings/addCurrencyListApi'
import { LoadingState, ValidationError } from '../../../../types/commonTypes'
import {
  GetAddCurrencyType,
  GetAddCurrencyTypeState,
  GetUpdatedCurrencyDetails,
} from '../../../../types/Invoicing/Invoices/Settings/addCurrencytype'
import { ApiLoadingState } from '../../../../middleware/api/apiList'
import { AppDispatch, RootState } from '../../../../stateStore'

const getAddCurrencyDetails = createAsyncThunk(
  'invoice/getInitData',
  async (_, thunkApi) => {
    try {
      return await addCurrencyListApi.getCurrencyDetails()
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)

const addCurrencyDetails = createAsyncThunk(
  'invoices/addCurrency',
  async (
    {
      currenyType,
      inrAmount,
    }: {
      currenyType: string
      inrAmount: number
    },
    thunkApi,
  ) => {
    try {
      return await addCurrencyListApi.addCurrencyDetails({
        currenyType,
        inrAmount,
      })
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)

const updateCurrencyDetails = createAsyncThunk<
  number | undefined,
  GetUpdatedCurrencyDetails,
  {
    dispatch: AppDispatch
    state: RootState
    rejectValue: ValidationError
  }
>(
  'invoices/updateInrToCurrency',
  async (updatedCurrency: GetUpdatedCurrencyDetails, thunkApi) => {
    try {
      return await addCurrencyListApi.editAddCurrencyDetails(updatedCurrency)
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)
export const initialAddCurrencyState: GetAddCurrencyTypeState = {
  getAddCurrencyDetails: {} as GetAddCurrencyType,
  isLoading: ApiLoadingState.succeeded,
}
const addCurrencySlice = createSlice({
  name: 'invoices',
  initialState: initialAddCurrencyState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAddCurrencyDetails.fulfilled, (state, action) => {
      state.getAddCurrencyDetails = action.payload
      state.isLoading = ApiLoadingState.succeeded
    })
    builder.addCase(addCurrencyDetails.fulfilled, (state) => {
      state.isLoading = ApiLoadingState.succeeded
    })
    builder.addCase(updateCurrencyDetails.fulfilled, (state) => {
      state.isLoading = ApiLoadingState.succeeded
    })
    builder.addMatcher(
      isAnyOf(
        getAddCurrencyDetails.pending,
        addCurrencyDetails.pending,
        updateCurrencyDetails.pending,
      ),
      (state) => {
        state.isLoading = ApiLoadingState.loading
      },
    )
  },
})
const getIntialDataThunk = {
  getAddCurrencyDetails,
  addCurrencyDetails,
  updateCurrencyDetails,
}
const isLoading = (state: RootState): LoadingState =>
  state.addCurrency.isLoading
const addCurrency = (state: RootState): GetAddCurrencyType =>
  state.addCurrency.getAddCurrencyDetails

const addCurrencySelectors = {
  isLoading,
  addCurrency,
}
export const addCurrencyService = {
  ...getIntialDataThunk,
  actions: addCurrencySlice.actions,
  selectors: addCurrencySelectors,
}
export default addCurrencySlice.reducer
